import React from "react";
import ReactDOM from "react-dom/client";

import App from "./core/app";
import { ThemeProvider } from "./core/themeContext";
import { restorePathAfterVersionRedirect } from "./hooks/useVersionUpdate";

import "./styles/styles.scss";

// Restore the original path after a version redirect. Must run BEFORE React
// renders so BrowserRouter sees the correct URL on first render.
restorePathAfterVersionRedirect();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
